import i18n from 'modules/core/lib/i18n'

/**
 * Given an attribute returns the header localized for the import table
 * This method aims to avoid I18n interpolation
 * @see https://www.notion.so/factorialco/Code-Pain-568f3ee12e7446fd875c6c3294d2fd7b?p=cccebffa0f934305af9e0edc663788de
 */
const getAttributeHeader = (attribute: string) => {
  switch (attribute) {
    case 'first_name':
      return i18n.t('import_contract.table.headers.first_name')
    case 'last_name':
      return i18n.t('import_contract.table.headers.last_name')
    case 'email':
      return i18n.t('import_contract.table.headers.email')
    case 'effective_on':
      return i18n.t('import_contract.table.headers.effective_on')
    case 'job_catalog_level_name':
      return i18n.t('import_contract.table.headers.job')
    case 'job_title':
      return i18n.t('import_contract.table.headers.job_title')
    case 'contract_end_date':
      return i18n.t('import_contract.table.headers.contract_end_date')
    case 'contract_start_date':
      return i18n.t('import_contract.table.headers.contract_start_date')
    case 'work_schedule_hours':
      return i18n.t('import_contract.table.headers.work_schedule_hours')
    case 'work_schedule_unit':
      return i18n.t('import_contract.table.headers.work_schedule_unit')
    case 'max_legal_yearly_hours':
      return i18n.t('import_contract.table.headers.max_legal_yearly_hours')
    case 'maximum_weekly_hours':
      return i18n.t('import_contract.table.headers.maximum_weekly_hours')
    case 'gross_salary_amount':
      return i18n.t('import_contract.table.headers.gross_salary_amount')
    case 'gross_salary_type':
      return i18n.t('import_contract.table.headers.gross_salary_type')
    case 'payroll_policies':
      return i18n.t('import_contract.table.headers.payroll_policies')
    case 'trial_period':
      return i18n.t('import_contract.table.headers.trial_period')
    case 'trial_period_end_date':
      return i18n.t('import_contract.table.headers.trial_period_end_date')
    case 'es_has_teleworking_contract':
      return i18n.t('import_contract.table.headers.es_has_teleworking_contract')
    case 'es_cotization_group_name':
      return i18n.t('import_contract.table.headers.es_cotization_group_name')
    case 'es_contract_observations':
      return i18n.t('import_contract.table.headers.es_contract_observations')
    case 'es_job_description':
      return i18n.t('import_contract.table.headers.es_job_description')
    case 'es_contract_type_name':
      return i18n.t('import_contract.table.headers.es_contract_type_name')
    case 'es_working_day_type_name':
      return i18n.t('import_contract.table.headers.es_working_day_type_name')
    case 'es_professional_category_name':
      return i18n.t('import_contract.table.headers.es_professional_category_name')
    case 'fr_employee_type_name':
      return i18n.t('import_contract.table.headers.fr_employee_type')
    case 'fr_forfait_jours':
      return i18n.t('import_contract.table.headers.fr_forfait_jours')
    case 'fr_jours_par_an':
      return i18n.t('import_contract.table.headers.fr_jours_par_an')
    case 'fr_coefficient':
      return i18n.t('import_contract.table.headers.fr_coefficient')
    case 'fr_contract_type_name':
      return i18n.t('import_contract.table.headers.fr_contract_type_name')
    case 'fr_level_name':
      return i18n.t('import_contract.table.headers.fr_level_name')
    case 'fr_step_name':
      return i18n.t('import_contract.table.headers.fr_step_name')
    case 'fr_mutual_name':
      return i18n.t('import_contract.table.headers.fr_mutual_name')
    case 'fr_professional_category_name':
      return i18n.t('import_contract.table.headers.fr_professional_category_name')
    case 'fr_work_type_name':
      return i18n.t('import_contract.table.headers.fr_work_type_name')
    case 'de_contract_type_name':
      return i18n.t('import_contract.table.headers.de_contract_type_name')
    case 'pt_contract_type_name':
      return i18n.t('import_contract.table.headers.pt_contract_type_name')
    case 'es_education_level_name':
      return i18n.t('import_contract.table.headers.es_education_level_name')
    default:
      throw new Error(`Missing translation for import_contract.table.headers.${attribute}`)
  }
}

export default getAttributeHeader
